"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _FormattedJSXMessage = _interopRequireDefault(require("I18n/components/FormattedJSXMessage"));

var _UILink = _interopRequireDefault(require("UIComponents/link/UILink"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _PriceDisplay = _interopRequireDefault(require("../common/pricing/PriceDisplay"));

var _UIBox = _interopRequireDefault(require("UIComponents/layout/UIBox"));

var _colors = require("HubStyleTokens/colors");

var _urls = require("../../utils/urls");

var BannerLayout = (0, _styledComponents.default)(_UIBox.default).withConfig({
  displayName: "SuiteCovidPromoBanner__BannerLayout",
  componentId: "sc-1qbvaij-0"
})(["background-color:", ";margin:0 auto;font-size:14px;padding:", ";", ";"], _colors.CALYPSO_LIGHT, function (_ref) {
  var yPadding = _ref.yPadding,
      xPadding = _ref.xPadding;
  return yPadding + "px " + xPadding + "px";
}, function (_ref2) {
  var width = _ref2.width;
  return width ? "max-width: " + width + ";" : '';
});
var LocaleToLearnMoreUrl = {
  en: 'https://offers.hubspot.com/customer-changes-march-2020',
  es: 'https://offers.hubspot.es/customer-changes-march-2020',
  fr: 'https://offers.hubspot.fr/changements-apportes-mars-2020',
  de: 'https://offers.hubspot.de/customer-changes-march-2020',
  ja: 'https://offers.hubspot.jp/customer-changes-march-2020',
  pt: 'https://br.hubspot.com/ofertas/customer-changes-march-2020'
};

var Bold = _styledComponents.default.b.withConfig({
  displayName: "SuiteCovidPromoBanner__Bold",
  componentId: "sc-1qbvaij-1"
})([""]);

var SuiteCovidPromoBanner = function SuiteCovidPromoBanner(_ref3) {
  var toPrice = _ref3.toPrice,
      fromPrice = _ref3.fromPrice,
      currencyCode = _ref3.currencyCode,
      _ref3$width = _ref3.width,
      width = _ref3$width === void 0 ? null : _ref3$width,
      _ref3$xPadding = _ref3.xPadding,
      xPadding = _ref3$xPadding === void 0 ? 60 : _ref3$xPadding,
      _ref3$yPadding = _ref3.yPadding,
      yPadding = _ref3$yPadding === void 0 ? 10 : _ref3$yPadding,
      _ref3$className = _ref3.className,
      className = _ref3$className === void 0 ? '' : _ref3$className;
  return _react.default.createElement(BannerLayout, {
    width: width,
    xPadding: xPadding,
    yPadding: yPadding,
    className: className
  }, _react.default.createElement(_FormattedJSXMessage.default, {
    message: "pricingPage.pages.growthSuite.covidStarterDiscountBanner_jsx",
    options: {
      currencyCode: currencyCode,
      fromPrice: fromPrice,
      toPrice: toPrice,
      href: (0, _urls.langToUrl)(LocaleToLearnMoreUrl)
    },
    elements: {
      Price: _PriceDisplay.default,
      UILink: _UILink.default,
      strong: Bold
    }
  }));
};

var _default = SuiteCovidPromoBanner;
exports.default = _default;
module.exports = exports.default;